import React, { createContext, FC, useContext, useMemo, useState } from 'react';

type SemFiltersBottomDrawerActionsContextType = {
  open: () => void;
  close: () => void;
  apply: () => void;
  set: (boolean) => void;
};

const SemFiltersBottomDrawerContext = createContext(false);
const SemFiltersBottomDrawerActionsContext = createContext({
  open: () => {},
  close: () => {},
  apply: () => {},
  set: (_: boolean) => {},
});

const SemFiltersBottomDrawerProvider: FC = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const actions = useMemo(
    () => ({
      open: (): void => setOpen(true),
      close: (): void => setOpen(false),
      apply: (): void => setOpen(false),
      set: setOpen,
    }),
    [setOpen]
  );

  return (
    <SemFiltersBottomDrawerContext.Provider value={isOpen}>
      <SemFiltersBottomDrawerActionsContext.Provider value={actions}>
        {children}
      </SemFiltersBottomDrawerActionsContext.Provider>
    </SemFiltersBottomDrawerContext.Provider>
  );
};

export const useIsSemFiltersBottomDrawerOpen = (): boolean =>
  useContext(SemFiltersBottomDrawerContext);
export const useSemFiltersBottomDrawerActions =
  (): SemFiltersBottomDrawerActionsContextType =>
    useContext(SemFiltersBottomDrawerActionsContext);
export default SemFiltersBottomDrawerProvider;
